import { useEffect } from "react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Marquee } from "@/components/Marquee";
import { StickyCTA } from "@/components/StickyCTA";
import { Hero } from "@/components/sections/Hero";
import { Situations } from "@/components/sections/Situations";
import { Method } from "@/components/sections/Method";
import { BeforeYouSend } from "@/components/sections/BeforeYouSend";
import { Children } from "@/components/sections/Children";
import { WhyLuke } from "@/components/sections/WhyLuke";
import { WhatThisIs } from "@/components/sections/WhatThisIs";
import { FirstWalk } from "@/components/sections/FirstWalk";
import { WalkWithMe } from "@/components/sections/WalkWithMe";
import { WhyWalk } from "@/components/sections/WhyWalk";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { track } from "@/lib/api";

export default function Landing() {
  useEffect(() => {
    track("page_view", { page: "landing" });
  }, []);

  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <Situations />
      <Method />
      <BeforeYouSend />
      <Children />
      <WhyLuke />
      <WhatThisIs />
      <FirstWalk />
      <WalkWithMe />
      <WhyWalk />
      <FinalCTA />
      <Footer />
      <StickyCTA />
    </main>
  );
}
